export default {
    APP_NAME: 'VCC',
    DOMAIN: 'https://vcc.accupin.com',
    BASE_API: 'https://vcc.accupin.com/api'
}